import polyglotI18nProvider from 'ra-i18n-polyglot';

const koreanMessages = {
  ra: {
    action: {
      add_filter: '필터 추가',
      add: '추가',
      back: '뒤로',
      bulk_actions: '%{smart_count}개 선택됨',
      cancel: '취소',
      clear_input_value: '값 지우기',
      clone: '복제',
      confirm: '확인',
      create: '생성',
      delete: '삭제',
      edit: '편집',
      export: '내보내기',
      list: '목록',
      refresh: '새로고침',
      remove_filter: '필터 제거',
      remove: '제거',
      save: '저장',
      search: '검색',
      show: '보기',
      sort: '정렬',
      undo: '실행 취소',
      unselect: '선택 해제',
      expand: '펼치기',
      close: '닫기',
      open_menu: '메뉴 열기',
      close_menu: '메뉴 닫기',
    },
    boolean: {
      true: '예',
      false: '아니오',
      null: '',
    },
    page: {
      create: '%{name} 생성',
      dashboard: '대시보드',
      edit: '%{name} #%{id}',
      error: '오류가 발생했습니다',
      list: '%{name}',
      loading: '로딩 중...',
      not_found: '찾을 수 없습니다',
      show: '%{name} #%{id}',
      empty: '%{name}이(가) 없습니다',
      invite: '추가하시겠습니까?',
    },
    input: {
      file: {
        upload_several: '업로드할 파일을 드래그하거나 클릭하여 선택하세요.',
        upload_single: '업로드할 파일을 드래그하거나 클릭하여 선택하세요.',
      },
      image: {
        upload_several: '업로드할 이미지를 드래그하거나 클릭하여 선택하세요.',
        upload_single: '업로드할 이미지를 드래그하거나 클릭하여 선택하세요.',
      },
      references: {
        all_missing: '참조 데이터를 찾을 수 없습니다.',
        many_missing: '연결된 참조를 더 이상 사용할 수 없습니다.',
        single_missing: '연결된 참조를 더 이상 사용할 수 없습니다.',
      },
      password: {
        toggle_visible: '비밀번호 숨기기',
        toggle_hidden: '비밀번호 표시',
      },
    },
    message: {
      about: '정보',
      are_you_sure: '계속하시겠습니까?',
      bulk_delete_content: '정말로 %{name}을(를) 삭제하시겠습니까? |||| 정말로 %{smart_count}개 항목을 삭제하시겠습니까?',
      bulk_delete_title: '%{name} 삭제 |||| %{name} %{smart_count}개 삭제',
      bulk_update_content: '정말로 %{name}을(를) 업데이트하시겠습니까? |||| 정말로 %{smart_count}개 항목을 업데이트하시겠습니까?',
      bulk_update_title: '%{name} 업데이트 |||| %{name} %{smart_count}개 업데이트',
      delete_content: '정말로 이 항목을 삭제하시겠습니까?',
      delete_title: '%{name} #%{id} 삭제',
      details: '상세정보',
      error: '클라이언트 오류가 발생하여 요청을 완료할 수 없습니다.',
      invalid_form: '양식이 올바르지 않습니다. 오류를 확인하세요.',
      loading: '페이지를 로딩 중입니다. 잠시만 기다려주세요.',
      no: '아니오',
      not_found: '잘못된 URL을 입력했거나 잘못된 링크를 클릭했습니다.',
      yes: '예',
      unsaved_changes: '변경사항이 저장되지 않았습니다. 무시하시겠습니까?',
    },
    navigation: {
      no_results: '결과를 찾을 수 없습니다',
      no_more_results: '%{page} 페이지 번호가 범위를 벗어났습니다. 이전 페이지를 시도하세요.',
      page_out_of_boundaries: '%{page} 페이지 번호가 범위를 벗어났습니다',
      page_out_from_end: '마지막 페이지 이후로 이동할 수 없습니다',
      page_out_from_begin: '1페이지 이전으로 이동할 수 없습니다',
      page_range_info: '%{offsetBegin}-%{offsetEnd} / %{total}',
      page_rows_per_page: '페이지당 행 수:',
      next: '다음',
      prev: '이전',
      skip_nav: '콘텐츠로 건너뛰기',
    },
    sort: {
      sort_by: '%{field} %{order}로 정렬',
      ASC: '오름차순',
      DESC: '내림차순',
    },
    auth: {
      auth_check_error: '계속하려면 로그인하세요',
      user_menu: '프로필',
      username: '사용자명',
      password: '비밀번호',
      sign_in: '로그인',
      sign_in_error: '인증 실패, 다시 시도하세요',
      logout: '로그아웃',
    },
    notification: {
      updated: '항목이 업데이트되었습니다 |||| %{smart_count}개 항목이 업데이트되었습니다',
      created: '항목이 생성되었습니다',
      deleted: '항목이 삭제되었습니다 |||| %{smart_count}개 항목이 삭제되었습니다',
      bad_item: '잘못된 항목',
      item_doesnt_exist: '항목이 존재하지 않습니다',
      http_error: '서버 통신 오류',
      data_provider_error: '데이터 제공자 오류. 자세한 내용은 콘솔을 확인하세요.',
      i18n_error: 'i18n 오류',
      canceled: '작업이 취소되었습니다',
      logged_out: '세션이 종료되었습니다. 다시 연결하세요.',
    },
    validation: {
      required: '필수 입력 항목입니다',
      minLength: '%{min}자 이상이어야 합니다',
      maxLength: '%{max}자 이하여야 합니다',
      minValue: '%{min} 이상이어야 합니다',
      maxValue: '%{max} 이하여야 합니다',
      number: '숫자여야 합니다',
      email: '올바른 이메일 주소여야 합니다',
      oneOf: '다음 중 하나여야 합니다: %{options}',
      regex: '특정 형식(정규식)과 일치해야 합니다: %{pattern}',
    },
    configurable: {
      customize: '사용자 정의',
    },
  },
  resources: {
    products: {
      name: '상품 |||| 상품',
      empty: '상품이 없습니다',
      invite: '상품을 추가하시겠습니까?',
    },
    categories: {
      name: '카테고리 |||| 카테고리',
      empty: '카테고리가 없습니다',
      invite: '카테고리를 추가하시겠습니까?',
    },
    orders: {
      name: '주문 |||| 주문',
      empty: '주문이 없습니다',
      invite: '주문을 추가하시겠습니까?',
    },
    users: {
      name: '회원 |||| 회원',
      empty: '회원이 없습니다',
      invite: '회원을 추가하시겠습니까?',
    },
    reviews: {
      name: '리뷰 |||| 리뷰',
      empty: '리뷰가 없습니다',
      invite: '리뷰를 추가하시겠습니까?',
    },
    coupons: {
      name: '쿠폰 |||| 쿠폰',
      empty: '쿠폰이 없습니다',
      invite: '쿠폰을 추가하시겠습니까?',
    },
    banners: {
      name: '배너 |||| 배너',
      empty: '배너가 없습니다',
      invite: '배너를 추가하시겠습니까?',
    },
    notices: {
      name: '공지사항 |||| 공지사항',
      empty: '공지사항이 없습니다',
      invite: '공지사항을 추가하시겠습니까?',
    },
    inquiries: {
      name: '문의 |||| 문의',
      empty: '문의가 없습니다',
      invite: '문의를 추가하시겠습니까?',
    },
    'deal-featured': {
      name: '캣츄딜 |||| 캣츄딜',
      empty: '캣츄딜이 없습니다',
      invite: '캣츄딜을 추가하시겠습니까?',
    },
  },
};

export default polyglotI18nProvider(() => koreanMessages, 'ko');
